import { nullable2undefinable } from 'core/utils/commonUtils';
import { http } from 'core/utils/httpClient';
import type { CreateOrUpdateOrderDiscountRequest } from './dtoModels/order/createOrUpdateOrderDiscountRequest';
import type { OrderDiscountInfoResponse } from './dtoModels/order/orderDiscountInfoResponse';
import type { OrderDiscountInfo } from 'models/order/orderDiscountInfo';

export const mapOrderDiscount = (
  source: OrderDiscountInfoResponse
): OrderDiscountInfo => ({
  ...source,
  dateCreate: new Date(source.dateCreate),
  user: nullable2undefinable(source.user),
});

export const mapOrderDiscounts = (
  source: OrderDiscountInfoResponse[]
): OrderDiscountInfo[] => source.map((ds) => mapOrderDiscount(ds));

export async function getOrderDiscountsAsync(
  orderId: number
): Promise<OrderDiscountInfo[]> {
  const { data } = await http.get<OrderDiscountInfoResponse[]>(
    `orders/${orderId}/discounts`
  );

  return mapOrderDiscounts(data);
}

export async function createOrderDiscountAsync(
  orderId: number,
  request: CreateOrUpdateOrderDiscountRequest
): Promise<OrderDiscountInfo> {
  const { data } = await http.post<OrderDiscountInfoResponse>(
    `orders/${orderId}/discounts`,
    request
  );
  return mapOrderDiscount(data);
}

export async function updateOrderDiscountAsync(
  orderId: number,
  discountId: number,
  request: CreateOrUpdateOrderDiscountRequest
): Promise<OrderDiscountInfo> {
  const { data } = await http.put<OrderDiscountInfoResponse>(
    `orders/${orderId}/discounts/${discountId}`,
    request
  );
  return mapOrderDiscount(data);
}

export async function deleteOrderDiscountAsync(
  orderId: number,
  discountId: number
): Promise<void> {
  await http.delete(`orders/${orderId}/discounts/${discountId}`);
}
